import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useI18n } from '../../hooks/useI18n';

const Box = styled.div`
  padding: 2rem 0;
  text-align: center;
`;
const H1 = styled.h1`
  margin: 0 0 0.5rem;
  font-size: ${({ theme }) => theme.fontClamp['2xl']};
`;
const A = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
`;

export default function NotFound() {
  const { t } = useI18n();
  return (
    <Box>
      <H1>{t('page.notFound.title', 'Page not found')}</H1>
      <A to="/">{t('page.notFound.backHome', 'Back home')}</A>
    </Box>
  );
}
